define((require) => {
    "use strict";

    const template           = require("ui/projects/image/ProjectImageView.tpl");
    const _                  = require("underscore");
    const ImageThumbnailView = require("ui/assets/image/ImageThumbnailView");
    const ProjectAsset       = require("ui/editor/project/ProjectAsset");
    const Tooltip            = require("ui/common/Tooltip");

    /**
     * Subclass of ImageThumbnailView representing the item view for the Image dashboard element in a project context. <p>
     *
     * @class ProjectDashboardImageView
     * @see ImageThumbnailView
     */
    return ImageThumbnailView.extend({

        template,

        /**
         * @type {ProjectModel}
         */
        _project: null,

        templateHelpers() {
            const parentTemplateHelpers = this.__super();

            // Extending the parent templateHelpers
            return _.defaults({
                showImageActionsPanel: this.options.showImageActionsPanel,
                isLocked: this._project.containsInferredAsset(this.model.get("id"))
            }, parentTemplateHelpers);
        },

        ui() {
            return _.extend({}, ImageThumbnailView.prototype.ui, {
                noDetachImage: ".no-detach",
                detachImage: ".detach"
            });
        },

        events() {
            return _.defaults({
                "click @ui.detachImage": "_detachImageClickHandler",

                // Override super 'deleteImage' event handler, to proper detach and delete...
                "click @ui.deleteImage": "_deleteImageClickHandler"
            }, ImageThumbnailView.prototype.events);
        },

        initialize() {
            this.__super();

            // Store a reference to the current project
            this._project = this.options.project;

            // Re-render *this* item view if it's status as a "inferred asset" changes
            this.listenTo(this._project.get("inferredAssets"), "add remove", (asset) => {
                if (asset.get("resourceType") === ProjectAsset.Type.IMAGE &&
                    asset.get("resourceId") === this.model.get("id")) {
                    this.render();
                }
            });
        },

        _deleteImageClickHandler() {
            if (this.options.isEditable && !this.model.get("timesUsed") && confirm("Are you sure you want to delete this image?")) {
                const image = this.model;
                const project = this._project;

                // First detach the image from the project, then delete it permanently.
                project.detach(image)
                    .then(() => {
                        return image.destroy();
                    });
            }
        },

        _detachImageClickHandler() {
            if (this.options.isEditable) {
                const imageModel = this.model;

                Tooltip.remove(this.ui.detachImage);

                return this._project.detach(imageModel)
                    .then(() => {
                        this.trigger("detach", imageModel);
                    })
                    .always(() => {
                        this.trigger("close");
                    });
            }
        },

        onRender() {
            this.__super();

            Tooltip.add(this.ui.noDetachImage, {
                placement: "top",
                width: 260
            });

            Tooltip.add(this.ui.detachImage, {
                placement: "top",
                width: this.options.isEditable ? 110 : 180
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/image/ProjectDashboardImageView.js